import { render, staticRenderFns } from "./ProductSegmentExplore.vue?vue&type=template&id=f41f4f0e"
import script from "./ProductSegmentExplore.vue?vue&type=script&lang=ts"
export * from "./ProductSegmentExplore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports